import React from 'react';
import { FileImage, Upload } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

interface MediaUploadProps {
  type: 'image' | 'video';
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
}

export default function MediaUpload({ type, value, onChange, error }: MediaUploadProps) {
  const { theme } = useTheme();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // In a real app, this would upload to a CDN
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className={`
      border-2 border-dashed rounded-lg p-4 text-center cursor-pointer
      ${theme === 'dark'
        ? 'border-gray-600 hover:border-gray-500'
        : 'border-gray-300 hover:border-gray-400'
      }
      ${error ? 'border-red-500' : ''}
    `}>
      <input
        type="file"
        accept={type === 'image' ? 'image/*' : 'video/*'}
        onChange={handleFileChange}
        className="hidden"
        id="media-upload"
      />
      <label htmlFor="media-upload" className="cursor-pointer">
        {value ? (
          type === 'image' ? (
            <img
              src={value}
              alt="Preview"
              className="max-h-48 mx-auto rounded-lg"
            />
          ) : (
            <video
              src={value}
              className="max-h-48 mx-auto rounded-lg"
              controls
            />
          )
        ) : (
          <div className={`py-8 ${
            theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
          }`}>
            {type === 'image' ? (
              <FileImage className="h-12 w-12 mx-auto mb-2" />
            ) : (
              <Upload className="h-12 w-12 mx-auto mb-2" />
            )}
            <p>Click to upload {type}</p>
          </div>
        )}
      </label>
    </div>
  );
}